import { StepClaimStatus } from 'store/modules/claims/types';
import { Tooltip } from '@grupoboticario/flora-react';
import { STATUS_OBJ } from 'utils/statusEnum';
import {
  ClaimStatusWrapper,
  ClaimStatusContent,
  IconWrapper,
  ActionButton,
  ClaimStatusSection,
} from './styles';

export type TagType = 'normal' | 'warning' | 'error' | 'default';

export function ClaimStatus({
  claimId,
  date,
  status,
  color,
  icon: Icon,
  description,
  onButtonClick,
  buttonTitle,
}: Readonly<StepClaimStatus>) {
  return (
    <ClaimStatusSection>
      <ClaimStatusWrapper color={color}>
        {status === STATUS_OBJ.Pendent ? (
          <Tooltip
            text="Olá tudo bem?</br>
          Para agilizar este processo verifique as informações solicitadas clicando no botão abaixo da data."
          >
            <header>{status && <span className="tag">{status}</span>}</header>
          </Tooltip>
        ) : (
          <header>{status && <span className="tag">{status}</span>}</header>
        )}
        <IconWrapper color={color}>
          <div className="icon">{Icon && <Icon />}</div>
        </IconWrapper>
        <ClaimStatusContent color={color}>
          <span className="text">{description}</span>
          {date && <span className="date">{date.toString()}</span>}
          {onButtonClick && claimId && (
            <ActionButton onClick={() => onButtonClick(claimId)}>
              {buttonTitle}
            </ActionButton>
          )}
        </ClaimStatusContent>
        <div className="claimStatus-line" />
      </ClaimStatusWrapper>
    </ClaimStatusSection>
  );
}
